import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { Button, Icon } from '@ibk/shared-ui';
import styles from './TimeoutError.module.css';
export function TimeoutError(props) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { dataTestId, title, closeButtonText, submitButtonText, onCloseClick, onSubmitClick, closeButtonNavigateTo = '/home', submitButtonNavigateTo = '/conta-pj', showCloseButton = true, } = props;
    const handleCloseClick = () => {
        if (onCloseClick) {
            onCloseClick();
        }
        else {
            navigate(closeButtonNavigateTo);
        }
    };
    const handleSubmitClick = () => {
        if (onSubmitClick) {
            onSubmitClick();
        }
        else {
            navigate(submitButtonNavigateTo);
        }
    };
    return (_jsxs("section", { className: styles.main, "data-testid": `section-${dataTestId}-timeout-error`, children: [_jsxs("div", { className: styles.body, "data-testid": `div-${dataTestId}-timeout-error-body`, children: [_jsx(Icon, { name: 'circleInfo', alt: 'Circle Info', className: styles.icon }), _jsx("span", { className: styles.mediumSemiboldText, "data-testid": `span-${dataTestId}-timeout-error-title`, children: title ?? t('pix-timeout-error') })] }), _jsxs("div", { className: styles.footer, "data-testid": `div-${dataTestId}-timeout-error-footer`, children: [showCloseButton && (_jsx(Button, { type: 'button', dataTestId: `button-${dataTestId}-timeout-error-close`, size: 'medium', variant: 'secondary', onClick: handleCloseClick, className: styles.button, children: closeButtonText ?? t('close') })), _jsx(Button, { type: 'submit', dataTestId: `button-${dataTestId}-timeout-error-submit`, size: 'medium', variant: 'primary', onClick: handleSubmitClick, className: styles.button, children: submitButtonText ?? t('show-extract') })] })] }));
}
